import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { listNews } from "../../server/apihelper";
import { Link } from "react-router-dom";
import SEO from "../../common-components/SEO";

export const News = () => {
  const [newsList, setNewsList] = useState([]);
  const [category, setCategory] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const itemsPerPage = 15;

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    const query = `page=${page}&items_per_page=${itemsPerPage}&category=${category}`;
    listNews(query).then((res) => {
      if (page === 1) {
        setNewsList(res.data);
      } else {
        setNewsList((prev) => [...prev, ...res.data]);
      }

      if (!res.data || res.data.length < itemsPerPage) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }
    });
  }, [category, page]);

  function formatDate(dateString) {
    let date;

    // Handle DD/MM/YYYY format too
    if (dateString?.includes("/")) {
      const [day, month, year] = dateString.split("/");
      date = new Date(`${year}-${month}-${day}`);
    } else {
      date = new Date(dateString);
    }

    if (isNaN(date)) {
      console.error("Invalid date format:", dateString);
      return { day: "", month: "", year: "" };
    }

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" }); // e.g. "Oct"
    const year = date.getFullYear();

    return { day, month, year };
  }


  return (
    <>
      <SEO
        title="Latest Architecture College News and Events at McGAN’S Ooty School of Architecture | Top Architecture College in Tamil Nadu"
        description="Explore the latest news and events at McGAN’S Ooty School of Architecture, one of the leading architecture colleges in Tamil Nadu."
        url="https://mcgansarch.com/news"
      />
      <h1 style={{ display: "none" }}>Latest Architecture News from McGAN'S Ooty</h1>

      {/* Page Banner */}
      <div className="page-banner-area bg-1">
        <div className="container">
          <div className="page-banner-content">
            <h3 className="BannerHeader">News</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="navspace">News</li>
            </ul>
          </div>
        </div>
      </div>

      {/* News Section */}
      <div className="campus-life-area pt-100 pb-70">
        <div className="container">
          <div className="row justify-content-center">
            <h5>NEWS AT McGAN’S</h5>

            {newsList.map((item, index) => {
              console.log("@@@@", item.date);
              const { day, month, year } = formatDate(item.date);
              console.log("Formatted Date:", day, month, year);
              return (
                <div className="col-lg-4 col-md-6" key={index}>
                  <div className="single-events-card style-4">
                    <div className="events-image">
                      <Link
                        to={`/news-details/${item?.primaryId}`}
                        className="read-more-btn"
                      >
                        <img
                          src={item.image}
                          alt={item.title}
                          width={416}
                          height={251}
                        />
                      </Link>
                      <div className="date">
                        <span>{day}</span>
                        <p>{month} - {year}</p>

                      </div>
                    </div>
                    <div className="events-content">
                      <div className="admin">
                        <p>
                          <a>
                            <i className="ri-map-pin-line"></i>
                            {item.place}
                          </a>
                        </p>
                      </div>
                      <Link
                        to={`/news-details/${item?.primaryId}`}
                        className="read-more-btn"
                      >
                        <h3>{item.title}</h3>
                      </Link>
                      <Link
                        to={`/news-details/${item?.primaryId}`}
                        className="read-more-btn"
                      >
                        Read More<i className="flaticon-next"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Show More Button */}
          {hasMore && (
            <div className="text-center mt-4 mb-4">
              <button
                className="btn show-more-btn"
                style={{ backgroundColor: "#b20d12", border: "none" }}
                onClick={() => setPage((prev) => prev + 1)}
              >
                Show More
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};